/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  PostBackPmpfIstanzeImportaBody,
  PostBackPmpfIstanzeImportaParams,
  SQLTransferResponse,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Importa una serie di istanze procedimenti da PMPF
 * @summary Importa una serie di istanze procedimenti da PMPF
 */
export const postBackPmpfIstanzeImporta = (
  postBackPmpfIstanzeImportaBody: PostBackPmpfIstanzeImportaBody,
  params?: PostBackPmpfIstanzeImportaParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postBackPmpfIstanzeImportaBody.file);

  return apiClientRequest<SQLTransferResponse>(
    {
      url: `/framework-bo-procedimenti/pmpf/istanze/importa`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    },
    options,
  );
};

export const getPostBackPmpfIstanzeImportaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackPmpfIstanzeImporta>>,
    TError,
    {
      data: PostBackPmpfIstanzeImportaBody;
      params?: PostBackPmpfIstanzeImportaParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackPmpfIstanzeImporta>>,
  TError,
  {
    data: PostBackPmpfIstanzeImportaBody;
    params?: PostBackPmpfIstanzeImportaParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackPmpfIstanzeImporta>>,
    {
      data: PostBackPmpfIstanzeImportaBody;
      params?: PostBackPmpfIstanzeImportaParams;
    }
  > = props => {
    const { data, params } = props ?? {};

    return postBackPmpfIstanzeImporta(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackPmpfIstanzeImportaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackPmpfIstanzeImporta>>
>;
export type PostBackPmpfIstanzeImportaMutationBody =
  PostBackPmpfIstanzeImportaBody;
export type PostBackPmpfIstanzeImportaMutationError = ErrorType<unknown>;

/**
 * @summary Importa una serie di istanze procedimenti da PMPF
 */
export const usePostBackPmpfIstanzeImporta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackPmpfIstanzeImporta>>,
    TError,
    {
      data: PostBackPmpfIstanzeImportaBody;
      params?: PostBackPmpfIstanzeImportaParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackPmpfIstanzeImportaMutationOptions(options);

  return useMutation(mutationOptions);
};
